import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { createBroadviewClient, createClaimEvidenceClient } from "@broadview/api-client";
import { parseClientEnvironment } from "@broadview/config/client";
import { PortalBootstrap } from "./PortalBootstrap";
import { createPortalApiFetch } from "./lib/portal-api-fetch";
import { createPortalAuthClient } from "./lib/portal-auth";
import { createLiveProblemRecordReader } from "./lib/live-problem-records";
import "./styles.css";

const config = parseClientEnvironment(import.meta.env);
const auth = createPortalAuthClient(config.VITE_SUPABASE_URL, config.VITE_SUPABASE_PUBLISHABLE_KEY);
const portalApiFetch = createPortalApiFetch();
const client = createBroadviewClient({
  mode: config.VITE_DATA_PROVIDER === "api" ? "live" : "fixture",
  apiOrigin: config.VITE_API_BASE_URL,
  getAccessToken: auth.getAccessToken,
  fetchImpl: portalApiFetch,
});
const problemRecords =
  config.VITE_DATA_PROVIDER === "api"
    ? createLiveProblemRecordReader({
        apiOrigin: config.VITE_API_BASE_URL,
        getAccessToken: auth.getAccessToken,
        fetchImpl: portalApiFetch,
      })
    : undefined;
const claims =
  config.VITE_DATA_PROVIDER === "api"
    ? createClaimEvidenceClient({
        mode: "live",
        apiOrigin: config.VITE_API_BASE_URL,
        getAccessToken: auth.getAccessToken,
        fetchImpl: portalApiFetch,
      })
    : undefined;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PortalBootstrap client={client} auth={auth} problemRecords={problemRecords} claims={claims} />
  </StrictMode>,
);
